import { render, staticRenderFns } from "./LocalizationEditor.vue?vue&type=template&id=71ba053f&"
import script from "./LocalizationEditor.vue?vue&type=script&lang=js&"
export * from "./LocalizationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports